export default [{
  path: '/userCenter',
  name: 'userCenter',
  component: () => import(/* webpackChunkName: "userCenter" */'@/pages/userCenter/index.vue'),
  meta: {
    pageId: 10000,
    spm: 2300,
  },
}];
